import * as React from 'react'
import { ComponentClass, FunctionComponent, ReactElement } from 'react'
import { IDialogProps } from '@fluentui/react'
import { useBoolean } from '@fluentui/react-hooks'
import { Button, ButtonProps, Tooltip, TooltipProps } from '@fluentui/react-components'

export type Props<D extends Omit<IDialogProps, 'hidden' | 'onDismiss'>> = {
    tooltipProps: Partial<TooltipProps> & Pick<TooltipProps, 'content'>
    buttonProps: ButtonProps
    dialog: FunctionComponent<D> | ComponentClass<D>
    dialogProps?: D
}

// noinspection JSUnusedGlobalSymbols
export default function DialogButton<D extends IDialogProps>(props: Props<D>): ReactElement {
    const [hidden, { setFalse: openDialog, setTrue: closeDialog }] = useBoolean(true)
    return (
        <>
            <Tooltip relationship={'description'} withArrow {...props.tooltipProps}>
                <Button {...props.buttonProps} onClick={() => openDialog()} />
            </Tooltip>
            <props.dialog hidden={hidden} onDismiss={closeDialog} {...props.dialogProps} />
        </>
    )
}
